import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"padding":"0 1rem"} }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[2] || (_cache[2] = _createElementVNode("h1", null, "PrimeVue", -1 /* HOISTED */)),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Dropdown, {
        modelValue: $data.val,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.val) = $event)),
        items: $data.items,
        placeholder: "Select City"
      }, null, 8 /* PROPS */, ["modelValue", "items"]),
      _createVNode(_component_Button, { onClick: $options.onSendError }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createTextVNode("Send error to Sentry")
        ])),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["onClick"])
    ])
  ]))
}